import { makeStyles } from '@material-ui/core/styles';
export const useFormTagRangeStyles = makeStyles(theme => ({
  form: {
    flexGrow: 1
  }
}));
